import { type SlideDeckRole } from '../models/SlideDeckRole'
import { RoomState } from '../models/RoomState'

export function getGroupSizeConstraintsFromRoles(roles: SlideDeckRole[]) {
  // no roles case, if null return we can defer to default flow
  if (!roles.length) {
    return {
      min: 1,
      max: RoomState.maxAllowedUsers,
    }
  }

  // else construct the min/max from roles
  const { min, max } = roles.reduce(
    (acc, { data: { roleMin, roleMax } }) => {
      acc.min += roleMin
      acc.max += roleMax
      return acc
    },
    { min: 0, max: 0 }
  )

  // clap max group size to room state max allowed users
  const roomStateMaxUsers = RoomState.maxAllowedUsers

  return {
    // group size can be no smaller than 1
    min: Math.max(min, 1),
    // group size can be no larger than room state max allowed users
    max: Math.min(max, roomStateMaxUsers),
  }
}
